import React from "react";
import { Outlet, useLocation } from "react-router";
import Header from "@components/header/Header";
import Footer from "@components/footer/Footer";
import Sidebar from "@components/sidebar/Sidebar";
import { ROUTES } from "@routes/RouteConstant";

const Layout: React.FC = () => {
  const location = useLocation();
  const dashboard = location.pathname === ROUTES.DASHBOARD;
  return (
    <div className={`layout ${dashboard ? "gradient" : ""}`}>
      <Sidebar />
      <div className="main">
        <Header />
        <div className="content">
          <Outlet />
        </div>
        {!dashboard && <Footer />}
      </div>
    </div>
  );
};

export default Layout;
